import { IPartner } from 'clickNgo/entities/partner/models'

export const comparePartnerAddress = (partner: IPartner) => {
  return (
    partner.addressLine1 === partner.legalAddressLine1 &&
    partner.addressLine2 === partner.legalAddressLine2 &&
    partner.addressLine3 === partner.legalAddressLine3 &&
    partner.city === partner.legalCity &&
    partner.country === partner.legalCountry &&
    partner.state === partner.legalState &&
    partner.zipCode === partner.legalZipCode
  )
}
